import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { TrackEventContext } from 'common/containers/EventContainer';
import LandingInternalFeedbackHelmet from 'common/helmets/LandingInternalFeedbackHelmet';
import Button from 'common/inputs/Button';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';
import Link from 'common/Link';
import withContexts from 'common/util/withContexts';
import LandingCTAButtons from 'common/www/LandingCTAButtons';
import Point2 from 'img/landing/changelog-1.webp';
import Point1 from 'img/landing/internal-feedback-1.webp';
import Hero from 'img/landing/internal-feedback-hero.webp';

import 'css/components/www/_LandingSolutionsPage.scss';

class LandingInternalFeedback extends Component {
  static propTypes = {
    trackEvent: PropTypes.func,
  };

  componentDidMount() {
    const { trackEvent } = this.props;
    trackEvent('Viewed Internal Feedback Page');
  }

  render() {
    return (
      <div className="landingInternalFeedback landingSolutionsPage">
        <LandingInternalFeedbackHelmet />
        <div className="fullWidthContainer">
          <div className="header">
            <div className="left">
              <div className="text">
                <h1>Manage internal feedback from your&nbsp;team</h1>
                <p className="subheading">
                  As your team grows, feedback becomes hard to manage and often gets lost in
                  the&nbsp;shuffle.
                </p>
                <LandingCTAButtons renderDemoButton />
              </div>
            </div>
            <LazyLoadedImage loading="eager" src={Hero} alt="Internal feedback graphic" />
          </div>
        </div>
        <div className="mainContentContainer">
          <h2>Canny breaks down silos between internal&nbsp;teams</h2>
          <div className="point">
            <LazyLoadedImage
              loading="eager"
              src={Point1}
              alt="Keep track of feedback from internal teammates"
            />
            <div className="text">
              <h2 className="title">Stop losing track of internal&nbsp;feedback</h2>
              <p>
                Don’t let ideas from your team fall through the cracks—keep them all organized
                and&nbsp;accessible.
              </p>
              <ul>
                <li>
                  No more internal feedback getting lost in{' '}
                  <Link to="/integrations/slack">Slack</Link> or other communication&nbsp;channels
                </li>
                <li>Anyone on your team can chime in with context or additional&nbsp;ideas</li>
                <li>
                  Help your product team consider feedback without having many
                  one&#8209;to&#8209;one&nbsp;conversations
                </li>
              </ul>
            </div>
          </div>
          <div className="point">
            <LazyLoadedImage src={Point2} alt="Keep stakeholders informed on product changes" />
            <div className="text">
              <h2 className="title">Keep the whole company updated on product&nbsp;changes</h2>
              <p>With so much going on, it's easy for new features to go&nbsp;unnoticed.</p>
              <ul>
                <li>Bring everyone into the fold with simple roadmap&nbsp;updates</li>
                <li>
                  Keep an internal <Link to="/features/product-changelog">changelog</Link> so
                  everyone stays&nbsp;informed
                </li>
                <li>Empower customer-facing teams to sell upcoming&nbsp;features</li>
              </ul>
            </div>
          </div>
          <div className="featuresCTA">
            <div className="title">
              <div className="icon-bolt"></div>Powered by some awesome features—check them&nbsp;out!
            </div>
            <Link className="cta" to="/features">
              <Button buttonType="cannyButton" value="Learn More" />
            </Link>
          </div>
          <LandingFooterCTA style="solid" expanded={true} />
        </div>
      </div>
    );
  }
}

export default withContexts({ trackEvent: TrackEventContext })(LandingInternalFeedback);
